// extracted by mini-css-extract-plugin
export var activeFilterButton = "_q5-c";
export var backButton = "_q5-4";
export var backIcon = "_q5-5";
export var chevronShortcut = "_q5-6";
export var container = "_q5-1";
export var editor = "_q5-8";
export var editorWrapper = "_q5-7";
export var prefix = "_q5-2";
export var searchIcon = "_q5-3";
export var suffix = "_q5-9";
export var suffixContent = "_q5-a";
export var suffixText = "_q5-b";
export var wrapper = "_q5-0";